import React, { useState } from 'react';
import styled from 'styled-components';
import ActionButton from '@/common/components/buttons/ActionButton';
import { Colors } from '@/common/colors/colors';
import InvoiceTicket from '@/common/components/invoiceTicket/InvoiceTicket';
import CreateNewTicket from '@/pages/consultant/dashboard/panel/ticket/createNewTicket/CreateNewTicket';
import Icon from '@/common/components/Icon';

const Wrapper = styled.div`
	display: flex;
	gap: 20px;
`;

export const H5 = styled.strong`
	color: ${Colors.darkBlue};
	width: 110px;
	text-align: right;
	font-size: 24px;
	margin-top: 10px;
`;

export const Flex = styled.div`
	display: flex;
	margin-top: 80px;

	input::file-selector-button {
		border: 2px solid ${Colors.darkBlue};
		border-radius: 15px;
		background-color: transparent;
		font-style: italic;
		color: ${Colors.darkBlue};
		cursor: pointer;

		&:hover {
			transform: scale(1.05);
		}
	}
`;

const TicketsForCalling = ({ orderId, market }) => {
	const [showQuestionTicket, setShowQuestionTicket] = useState();
	const [showInvoiceTicket, setShowInvoiceTicket] = useState();

	return (
		<>
			{showQuestionTicket && (
				<CreateNewTicket
					orderId={orderId}
					setShowQuestionTicket={setShowQuestionTicket}
				/>
			)}
			<Wrapper>
				<div>
					<ActionButton
						color={Colors.orange}
						onClick={() => setShowQuestionTicket(true)}
					>
						<Icon name='question' style={{ marginRight: '10px' }}/>
						{'Question'}
					</ActionButton>
				</div>
				<div>
					<ActionButton onClick={() => setShowInvoiceTicket(true)}>
						<Icon name='file-invoice' style={{ marginRight: '10px' }} />
						{'Invoice'}
					</ActionButton>
				</div>
				{showInvoiceTicket && (
					<InvoiceTicket
						market={market}
						orderId={orderId}
						setShowInvoiceTicket={setShowInvoiceTicket}
					/>
				)}
			</Wrapper>
		</>
	);
};

export default TicketsForCalling;
